export enum CountrySelectorConstants {
  CS_ENDPOINT = '/{cc}/{lc}/download/download-api/getCountryLabels/',
  COUNTRY_CODE = 'ww',
  LANGUAGE_CODE = 'en',
  APP_SOURCE = 'SE',
  NOT_SCOPED_MESSAGE = 'The specified document is not available anywhere..',
  TOGGLE_CLICK = 'false',
}
